import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone, OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { EActiveTab } from '../../data-types/tabs.enum';
import { iconsLibrary } from '../../../theme/constants';
import { Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { alertSelector } from '../../store/selectors/alert.selector';
import { IAppState } from '../../store/state/app.state';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { closeLoadingAction, showLoadingAction } from '../../store/actions/loading.action';
import { LocalStorageService } from '../../services/local-storage.service';
import { EStorageType } from '../../data-types/storage.enum';
import { showAlertAction } from '../../store/actions/alert.action';
import { CoworkerService } from '../../services/coworker.service';
import { CoworkingService } from '../../services/coworking.service';
import * as moment from 'moment';
import { ECoworkerView } from '../../data-types/coworker.enums';
import { EInputStyleType } from '../../data-types/input-style.enum';
import { EFooterStyleInput } from '../../data-types/footer.enum';
declare var H: any;

@Component({
  selector: 'cowing-core-coworker-office',
  templateUrl: './coworker-office.component.html',
  styleUrls: ['./coworker-office.component.scss'],
})
export class CoworkerOfficeComponent implements OnInit, AfterViewInit, OnDestroy {
  private mapElement: ElementRef;
  private currentLocation: { latitude: number; longitude: number };
  private positionPostalCode = {
    latitude: 40,
    longitude: -4
  };
  public selectedMarker = null;
  private hereMap = null;
  private eventsSubscription: Subscription;
  private platform: any;
  public service: any;
  public showFilters = false;
  public showSelected = false;
  public EFooterStyleInput = EFooterStyleInput;
  public content: string = null;
  public EActiveTab = EActiveTab;
  public viewMode: ECoworkerView = ECoworkerView.List;
  public ECoworkerView = ECoworkerView;
  public EInputStyleType = EInputStyleType;
  public cities = [];
  public selectedCity = null;
  private tokenRefreshed = false;
  public coworkingsList = [];
  public citiesOptions = [];
  private markersGroup = null;
  public durations = null;
  public selectedDuration = null;
  public spaceTypes = null;
  public selectedSpaceType = null;
  public filterDay = null;
  public currentDistance = 0;
  public currentPrice = 0;
  private postalCode = '';
  alert$ = this._store.pipe(select(alertSelector));
  @ViewChild('map') set map(elRef: ElementRef) {
    if (elRef) {
      this.mapElement = elRef;
      this.addMap();
    }
  }
  @Input('isMobile') isMobile = false;
  @Input('getCoords') getCoords: () => Promise<{ latitude: number; longitude: number }>;
  @Input('getResume') getResume: Observable<{ resume: boolean, locationEnable: boolean }>;
  @Output('onActiveLocation') onActiveLocation: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _store: Store<IAppState>,
    private _router: Router,
    private translate: TranslateService,
    private chRef: ChangeDetectorRef,
    private _ngZone: NgZone
  ) {
    this.platform = new H.service.Platform({
      apikey: 'NogSDLNDmk3LGE8LE55oFPl3EPDeimpgGLBuk3ynCCE',
    });
    this.service = this.platform.getSearchService();
  }

  resetSelected() {
    this.showSelected = false;
  }

  ngOnInit() {
    this.eventsSubscription = this.getResume?.subscribe(async ({ resume, locationEnable }) => {
      if (locationEnable) {
        await this.getPromiseCoords();
      } else {
        this.currentLocation = null;
      }
      if (resume) {
        await this.fetchCoworkings();
      }
      this.ngZone();
    });
  }

  ngZone() {
    this._ngZone.run(() => {
      this.chRef.detach();
      this.chRef.detectChanges();
      this.chRef.reattach();
    });
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  postalCodeFromLocalStorage() {
    const postalCode = LocalStorageService.instance.get(EStorageType.PostalCode);
    return postalCode !== 'undefined' ? postalCode : '';
  }

  async getPromiseCoords() {
    const promiseCoords = await this.getCoords();
    if (promiseCoords.latitude && promiseCoords.longitude) {
      this.currentLocation = promiseCoords;
    }
  }

  async ngAfterViewInit() {
    this._store.dispatch(showLoadingAction({}));
    this.alert$.subscribe(async (alert) => {
      this.onActiveLocation.emit(alert);
    });
    this.postalCode = this.postalCodeFromLocalStorage();
    try {
      await this.getPromiseCoords();
    } catch (e) {
      if (e && e.code === 1) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message: this.translate.instant('general.no-location'),
              title: this.translate.instant('general.caution'),
              type: 'errorLocation',
              optionOkText: this.translate.instant('general.active-location'),
              optionCancelText: this.translate.instant('general.deactivate-location'),
            },
          })
        );
      }
      this.positionPostalCode = this.postalCode ? await this.getLongAndLatByPostalCode(this.postalCode) : this.positionPostalCode;
    }
    try {
      this.tokenRefreshed = true;
      const filter = this.getFilters();
      const responseCities = await CoworkerService.instance.getCities(filter);
      const { latitude, longitude } = this.positionPostalCode;
      const noCity = [
        {
          name: this.translate.instant('general.all'),
          latitude: this.currentLocation?.latitude || latitude,
          longitude: this.currentLocation?.longitude || longitude,
        },
      ];
      this.cities = noCity.concat(responseCities);

      this.selectedCity = this.cities[0];
      this.cities.forEach((element) => {
        this.citiesOptions.push(element.name);
      });

      await this.fetchCoworkings();
      const types = await CoworkingService.instance.getSpaceTypes();
      this.spaceTypes = types;
      const durations = await CoworkingService.instance.getPriceTypes();
      this.durations = durations;
    } catch (e) {
      if (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant('general.expired')
                  : e.data.error,
              title: this.translate.instant('general.caution'),
              type: 'error',
            },
          })
        );
      }
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  private async getLongAndLatByPostalCode(postalCode: string): Promise<any> {
    const searchLocationByPostalCode = await this.service.geocode({
      q: `${postalCode}, ES`
    });
    const { lat: latitude, lng: longitude } = searchLocationByPostalCode?.items[0].position;
    return { latitude, longitude };
  }

  public setNewDuration(event) {
    this.selectedDuration = this.durations.find((elem) => {
      return elem.title === event;
    });
  }

  public setNewType(event) {
    this.selectedSpaceType = this.spaceTypes.find((elem) => {
      return elem.title === event;
    });
  }

  public setNewDay(event) {
    if (typeof event === 'string') {
      this.filterDay = moment(event).format('yyyy-MM-DD');
    }
  }

  public newDistance(event) {
    this.currentDistance = event;
  }

  public newPrice(event) {
    this.currentPrice = event;
  }

  private addMap() {
    const defaultLayers = this.platform.createDefaultLayers();
    if (!this.hereMap) {
      this.hereMap = new H.Map(
        this.mapElement.nativeElement,
        defaultLayers.vector.normal.map,
        {
          zoom: 11,
          center: {
            lat: this.selectedCity ? this.selectedCity.latitude : 0,
            lng: this.selectedCity ? this.selectedCity.longitude : 0,
          },
        }
      );
      const ui = H.ui.UI.createDefault(this.hereMap, defaultLayers, 'es-ES');
      const mapEvents = new H.mapevents.MapEvents(this.hereMap);
      const behavior = new H.mapevents.Behavior(mapEvents);
    } else {
      this.hereMap.setCenter({
        lat: this.selectedCity.latitude,
        lng: this.selectedCity.longitude,
      });
    }

    if (this.markersGroup) { this.hereMap.removeObject(this.markersGroup); }
    this.markersGroup = new H.map.Group();

    this.coworkingsList.forEach((coworking) => {
      const newMarker = new H.map.Marker({
        lat: coworking.latitude,
        lng: coworking.longitude,
      });
      newMarker.setData({ coworking });
      this.markersGroup.addObject(newMarker);
    });

    this.markersGroup.addEventListener('tap', (event) => {
      this.showSelected = true;
      this.selectedMarker = event.target.getData();
    });

    this.hereMap.addObject(this.markersGroup);
  }

  public setView(newView: ECoworkerView) {
    if (newView === ECoworkerView.List) {
      this.hereMap = null;
      this.markersGroup = null;
    }
    this.viewMode = newView;
  }

  public toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  public async search() {
    this.showFilters = false;
    await this.fetchCoworkings();
  }

  public async newCity(newCity: string) {
    const index: number = this.cities.findIndex((elem) => {
      return elem.name === newCity;
    });
    if (index !== -1) {
      this.selectedCity = this.cities[index];
    }
    await this.fetchCoworkings();
  }

  public async cleanFilters() {
    this.currentPrice = 0;
    this.currentDistance = 0;
    this.selectedSpaceType = null;
    this.selectedDuration = null;
    this.filterDay = null;
    await this.fetchCoworkings();
  }

  public async fetchCoworkings() {
    this._store.dispatch(showLoadingAction({}));
    const filter = this.getFilters();
    this.coworkingsList = await CoworkerService.instance.getCoworkings(filter);
    this.ngZone();
    if (this.viewMode === ECoworkerView.Map) {
      this.addMap();
    }
    this._store.dispatch(closeLoadingAction({}));
  }

  private getFilters() {
    const filter: any = {};

    if (this.selectedCity) {
      filter.city = this.selectedCity.name;
    }

    if (this.currentLocation) {
      filter.localization = {
        distance: 100000000,
        latitude: this.currentLocation.latitude,
        longitude: this.currentLocation.longitude,
      };
      if (this.currentDistance && this.currentDistance > 0) {
        filter.localization.distance = this.currentDistance * 1000;
      }
    }

    if (this.selectedSpaceType) {
      filter.space_type_id = this.selectedSpaceType.id;
    }

    if (this.selectedDuration) {
      filter.duration_id = this.selectedDuration.id;
    }

    if (this.filterDay) {
      filter.day = moment(this.filterDay).format('DD/MM/YYYY');
    }

    if (this.currentPrice && this.currentPrice > 0) {
      filter.price = this.currentPrice;
    }

    filter.company_only = true;

    return filter;
  }

  public get getMapIcon() {
    return `${iconsLibrary.map}`;
  }

  public get getListIcon() {
    return `${iconsLibrary.list}`;
  }

  public get getCloseIcon() {
    return `${iconsLibrary.closeLight}`;
  }

  public get getFilterIcon() {
    return `${iconsLibrary.filter}`;
  }

  get getOfficeIcon() {
    return `${iconsLibrary.office}`;
  }
}
